module.exports = __webpack_public_path__ + "img/sung-hee-kim-teaching-in-laboratory.edef45a1.jpg";